import {useState,useEffect } from "react";
import styles from "./imageGallery.module.css";
import { FaChevronLeft, FaChevronRight, FaHeart, FaTimes } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { Button,Image } from "../shared/index";
import { getImageUrl } from "../../lib/get-image";
import { useAddToWishList, useRemoveWishList } from "../../queries/useWishListQuery";

const ImageGallery = ({ productId,images = [] ,wishItems=[]}) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setSelectedImage(0);
  }, [images]);
  const { mutate: addWish } = useAddToWishList();
  const { mutate: removeWish } = useRemoveWishList();
  const wishItem = wishItems?.find(
    (w) => Number(w?.product_id) === Number(productId)
  );

  const inWishList = Boolean(wishItem);
  const wishlistId = wishItem?.id;

  const handleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (inWishList) {
      removeWish(wishlistId);
    } else {
      addWish({ product_id: productId });
    }
  };


  const handleOpenModal = (index) => {
    setSelectedImage(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const handleNextImage = () => {
    setSelectedImage((prev) => (prev + 1) % images?.length);
  };

  const handlePrevImage = () => {
    setSelectedImage((prev) => (prev - 1 + images.length) % images?.length);
  };


  return (
    <>
      <div className={styles.galleryContainer}>
        <div className={styles.mainImageWrapper}>
          <Image
            src={getImageUrl(images[selectedImage]?.image)}
            alt="Main"
            className={styles.mainImage}
            onClick={() => handleOpenModal(selectedImage)}

          />
         <Button
            type="button"
            title={
              inWishList ? <FaHeart size={25} color="red" /> : <CiHeart size={25} />
            }
            style={styles.wishlistButton}
            onHandler={handleWishlist}
          />
        </div>

        <div className={styles.thumbnailRow}>
          <Button
            type="button"
            title={<FaChevronLeft size={20} />}
            style={styles.arrowBtn}
            onHandler={handlePrevImage}
          />

          <div className={styles.thumbnails}>
            {images?.map((item, index) => (
              <img
                key={index}
                src={getImageUrl(item?.image)}
                alt="thumb"
                className={`${styles.thumbnail} ${
                  selectedImage === index ? styles.activeThumb : ""
                }`}
                onClick={() => setSelectedImage(index)}
              />
            ))}
          </div>

          <Button
            type="button"
            title={<FaChevronRight size={20} />}
            style={styles.arrowBtn}
            onHandler={handleNextImage}
          />
        </div>
      </div>

      {isModalOpen && (
        <ImageModal
          images={images}
          selectedImage={selectedImage}
          handleCloseModal={handleCloseModal}
          handlePrevImage={handlePrevImage}
          handleNextImage={handleNextImage}
        />
      )}
    </>
  );
};

const ImageModal = ({
  images,
  selectedImage,
  handleCloseModal,
  handlePrevImage,
  handleNextImage,
}) => {
  return (
    <div className={styles.modalOverlay}>
      <Button
        type="button"
        title={<FaTimes size={20} />}
        style={styles.closeBtn}
        onHandler={handleCloseModal}
      />

      <Button
        type="button"
        title={<FaChevronLeft size={20} />}
        style={styles.modalNavLeft}
        onHandler={handlePrevImage}
      />

      <Image
        src={getImageUrl(images[selectedImage]?.image)}
        alt="Zoom"
        className={styles.modalImage}
      />

      <Button
        type="button"
        title={<FaChevronRight size={20} />}
        style={styles.modalNavRight}
        onHandler={handleNextImage}
      />
    </div>
  );
};

export default ImageGallery;
